import { Checkbox } from "@chakra-ui/react";

const AppCheckbox = ({
    children,
    checked,
    onCheckedChange,
    ...props
}) => {
    return (
        <Checkbox.Root
            checked={checked}
            onCheckedChange={onCheckedChange}
            {...props}
        >
            <Checkbox.HiddenInput />

            <Checkbox.Control
                borderColor="gray.300"
                _checked={{
                    bg: "#2453FF",
                    borderColor: "#2453FF",
                    color: "white",
                }}
            />

            <Checkbox.Label
                color="gray.600"
                fontSize="sm"
                cursor="pointer"
            >
                {children}
            </Checkbox.Label>
        </Checkbox.Root>
    );
};

export default AppCheckbox;